import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=71f0da7e"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports